export enum AmplitudeTrackingEvents {
    CALL_CLICK_CAMERA = 'call_click_camera',
    CALL_CLICK_CAPTIONS = 'call_click_captions',
    CALL_CLICK_DEVICE_SETTINGS = 'call_click_devicesettings',
    CALL_CLICK_MUTE = 'call_click_mute',
    CALL_CLICK_PAUSE = 'call_click_pause',
    CALL_CLICK_ENDCALL = 'call_click_endcall',
    CALL_CLICK_FULLSCREEN_VISUAL_AID = 'call_click_fullscreenvisualaid',
    CALL_CLICK_COLLAPSE_VISUAL_AID = 'call_click_collapsevisualaid',
    CALL_CLICK_SCREENSHARE_PIP_REOPEN = 'call_click_screensharepipreopen',
    DEVICE_SETTINGS_CLICK_SELECT_CAMERA = 'devicesettings_click_selectcamera',
    DEVICE_SETTINGS_CLICK_SELECT_MICROPHONE = 'devicesettings_click_selectmicrophone',
    END_CALL_CLICK_FEEDBACK = 'endcall_click_feedback',
    END_CALL_MODAL_CLICK_ENDCALL = 'endcallmodal_click_endcall',
    END_CALL_MODAL_CLICK_RESUME = 'endcallmodal_click_resume',
    END_CALL_PAGEVIEW = 'endcall_pageview',
    END_CALL_ERROR_MODAL_OK = 'endcall_errormodal_ok',
    END_CALL_ERROR_MODAL_ASSIGNMENT = 'endcall_errormodal_assignment',
    FTU_DEVICE_SETTINGS_CLICK_START_CALL = 'ftudevicesettings_click_startcall',
    PAUSE_MODAL_CLICK_DEVICE_SETTINGS = 'pausemodal_click_devicesettings',
    RESULTS_PAGE_PAGEVIEW = 'resultspage_pageview',
    RESULTS_PAGE_CLICK_MESSAGE_ADHERENCE_SCORE = 'resultspage_click_messageadherencescore',
    RESULTS_PAGE_CLICK_OBJECTIVES_SCORE = 'resultspage_click_objectivesscore',
    RESULTS_PAGE_CLICK_SKILLS_SCORE = 'resultspage_click_skillsscore',
    RESULTS_PAGE_CLICK_HOW_CALCULATED_LINK = 'resultspage_click_howcalculatedlink',
    SKILLS_PAGE_PAGEVIEW = 'skills_pageview',
    TRANSCRIPT_PAGE_VIEW = 'transcript_pageview',
    OBJECTIVE_PAGE_VIEW = 'objectives_pageview',
    MESSAGE_ADHERENCE_PAGE_VIEW = 'messageadherence_pageview',
    OBJECTIVE_CLICK_PRACTICE_AGAIN = 'objectives_click_practiceagain',
    MESSAGE_ADHERENCE_CLICK_PRACTICE_AGAIN = 'messageadherence_click_practiceagain',
    CALL_CLICK_DISPLAY_VISUAL_AID = 'call_click_displayvisualaid',
    CALL_CLICK_CLOSE_VISUAL_AID = 'call_click_closevisualaid',
    SURVEY_CERTIFICATION_COMPLETE = 'survey_certification_complete',
    SURVEY_RESULTS_FIRST_PRACTICE = 'survey_results_first_practice',
    LEADERBOARD_PAGEVIEW = 'leaderboard_pageview',
    LEADERBOARD_CLICK_ASSIGNMENT = 'leaderboard_click_assignment',
    LEADERBOARD_CLICK_SIMULATION = 'leaderboard_click_simulation',
    LEADERBOARD_CLICK_HEADER = 'leaderboard_click_header',
    REPORTINGDASHBOARD_PAGEVIEW = 'reportingdashboard_pageview',
    REPORTINGDASHBOARD_CLICK_PRACTICETAB = 'reportingdashboard_click_practicetab',
    REPORTINGDASHBOARD_CLICK_CERTIFICATIONTAB = 'reportingdashboard_click_certificationtab',
    REPORTINGDASHBOARD_CLICK_ASSIGNMENTFILTER = 'reportingdashboard_click_assignmentfilter',
    REPORTINGDASHBOARD_CLICK_PRACTICEASSIGNMENT = 'reportingdashboard_click_practiceassignment',
    REPORTINGDASHBOARD_CLICK_CERTIFICATIONASSIGNMENT = 'reportingdashboard_click_certificationassignment',
    REPORTINGDASHBOARD_CLICK_USERCOUNTCELL = 'reportingdashboard_click_usercountcell',
    REPORTINGDASHBOARD_CLICK_ASSIGNMENTSEARCH = 'reportingdashboard_click_assignmentsearch',
    REPORTINGDASHBOARD_INDIVIDUAL_ASSIGNMENT_PAGEVIEW = 'assignmentreport_pageview',
    REPORTINGDASHBOARD_CLICK_ENGAGEMENT_STATUS_FILTER = 'assignmentreport_click_usertable_statusfilter',
    REPORTINGDASHBOARD_CLICK_USER_TABLE_SEARCH = 'assignmentreport_click_usertable_search',
    REPORTINGDASHBOARD_CLICK_USER_NAME_FILTER = 'assignmentreport_click_sessiontable_username',
    REPORTINGDASHBOARD_CLICK_DATE_FILTER = 'assignmentreport_click_sessiontable_date',
    REPORTINGDASHBOARD_CLICK_SIMULATION_FILTER = 'assignmentreport_click_sessiontable_simulation',
    ASSIGNMENTREPORT_CLICK_SIMULATIONTABLE_SIMNAME = 'assignmentreport_click_simulationtable_simname',
    REPORTINGDASHBOARD_PERSONALIZED_PRACTICE_PAGEVIEW = 'personalizedpracticereportingdash_pageview',
    REPORTINGDASHBOARD_CLICK_PERSONALIZED_PRACTICE_TAB = 'personalizedpracticereportingdash_click_product',
    PERSONALIZED_PRACTICE_REPORTING_PAGE_FILTER_APPLIED = 'personalizedpracticereportingpage_filter_applied',
    PERSONALIZED_PRACTICE_DASH_PAGEVIEW = 'personalizedpracticedash_pageview',
    PERSONALIZED_PRACTICE_PAGE_PAGEVIEW = 'personalizedpracticepage_pageview',
    PERSONALIZED_PRACTICE_REPORTING_PAGE_PAGEVIEW = 'personalizedpracticereportingpage_pageview',
    PERSONALIZED_PRACTICE_CLICK_PRODUCT = 'personalizedpracticedash_click_product',
    PERSONALIZED_PRACTICE_PAGE_CUSTOMIZATION_CHANGE = 'personalizedpracticepage_change_customization',
    PERSONALIZED_PRACTICE_PAGE_CLICK_LAUNCH = 'personalizedpracticepage_click_launch',
    PERSONALIZED_PRACTICE_RESULTS_PAGE_PAGEVIEW = 'personalizedpracticeresultspage_pageview',
    PERSONALIZED_PRACTICE_RESULTS_PAGE_CLICK_PRACTICE_AGAIN = 'personalizedpracticeresultspage_click_practiceagain',
    HELPMODAL_CLICK_KNOWLEDGEBASE = 'helpmodal_click_knowledgebase',
    HELPSCOUT_BEACON_OPENED = 'helpscout_beacon_opened',
    USER_DETAIL_PAGE = 'userreport_pageview',
    USER_REPORT_EXPORT_CSV = 'userreport_click_exportcsv',
    USER_REPORT_ASSIGNMENT_FILTER = 'userreport_click_assignmentfilter',
    ASSIGNMENTREPORT_CLICK_SESSIONTABLE_SIMNAME = 'assignmentreport_click_sessiontable_simname',
    ASSIGNMENTREPORT_CLICK_ATTEMPTTABLE_SIMNAME = 'assignmentreport_click_attempttable_simname',
    SIMULATION_REPORT_PAGEVIEW = 'simulationreport_pageview',
    REPORTING_SESSIONS_CSV_EXPORTED = 'reporting_sessions_csv_exported',
    USER_REPORT_CLICK_SESSION_SIMULATION_NAME = 'userreport_click_sessiontable_simname',
    SIMBUILDER_SEARCH_SIMULATION = 'simbuilder_search_simulation',
    SIMBUILDER_SEARCH_ASSIGNMENT = 'simbuilder_search_assignment',
    COMPLIANCE_SCORE_IMPACT_SET = 'compliance_score_impact_set',
    REPORTING_USERS_CSV_EXPORTED = 'reporting_users_csv_exported',
    SELF_AUTHORING_SIMBUILDER_TAB_VIEWED = 'self_authoring_simbuilder_tab_viewed',
    SELF_AUTHORING_STARTED = 'self_authoring_started',
    SELF_AUTHORING_DOCUMENT_UPLOADED = 'self_authoring_document_uploaded',
    SELF_AUTHORING_CALL_DETAILS_VIEWED = 'self_authoring_call_details_viewed',
    SELF_AUTHORING_CALL_DETAILS_EXPORT_CLICKED = 'self_authoring_call_details_export_clicked',
    SELF_AUTHORING_FEEDBACK_SUBMITTED = 'self_authoring_feedback_submitted',
    SELF_AUTHORING_REFINEMENT_REQUEST_SUCCEEDED = 'self_authoring_refinement_request_succeeded',
    SELF_AUTHORING_REFINEMENT_REQUEST_FAILED = 'self_authoring_refinement_request_failed',
    SELF_AUTHORING_USER_VIEW_EDITED = 'self_authoring_user_view_edited',
    MESSAGING_THEME_ADDED = 'messaging_theme_added',
    MESSAGING_THEME_EDITED = 'messaging_theme_edited',
    MESSAGING_THEME_DELETED = 'messaging_theme_deleted',
    MESSAGING_FACT_ADDED = 'messaging_fact_added',
    MESSAGING_FACT_EDITED = 'messaging_fact_edited',
    MESSAGING_FACT_DELETED = 'messaging_fact_deleted',
    SCORING_ACCURACY = 'scoring_accuracy',
    GENERAL_SCREEN_SHARE = 'general_screenshare',
}
